import type { Model } from '@patsnap/tahiti-core';
import type { CreditData } from '../types';

export const CreditModel = Symbol('CreditModel');

/**
 * 点数（积分）模型
 */
export interface CreditModel extends Model<CreditData> {}
